import { useState } from "react";
import styled, { ThemeProvider } from "styled-components";
import { theme } from "../../pages/oeeDashboard/styles/theme";
import ImjaiChatbot from "./chatbot/ImjaiChatbot";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const LayoutWrapper = styled.div`
  display: flex;
  height: 100vh;
  background-color: ${({ theme }) =>
    theme.customColors?.background || "#0C111A"};
  color: ${({ theme }) => theme.customColors?.text || "#FFF"};
`;

const Content = styled.main`
  flex: 1;
  padding: 0.5rem 0.5rem;
  overflow-y: auto;
  margin-top: 60px;
  background-image: url("${process.env
    .PUBLIC_URL}/images/icons/Background.png") !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

export default function Layout({ children }) {
  const [showSidebar, setShowSidebar] = useState(false);

  const onCloseSideBar = () => {
    setShowSidebar(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Navbar setShowSidebar={setShowSidebar} />
      <LayoutWrapper>
        <Sidebar showSidebar={showSidebar} />
        <Content onClick={onCloseSideBar}>{children}</Content>
      </LayoutWrapper>
      <ImjaiChatbot />
    </ThemeProvider>
  );
}
